import latteArtImage from "@/assets/latte-art-hand.webp";
import baristaPouring from "@/assets/barista-pouring.webp";
import heroImage from "@/assets/hero-coffee.webp";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

const slides = [
  { image: heroImage, alt: "Kopi premium Crestora Coffee Roasters" },
  { image: latteArtImage, alt: "Seni latte oleh barista Crestora" },
  { image: baristaPouring, alt: "Barista menyajikan kopi spesial" },
];

const HeroSection = () => {
  const [current, setCurrent] = useState(0);
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    setTextVisible(false);
    const t = setTimeout(() => setTextVisible(true), 200);
    return () => clearTimeout(t);
  }, [current]);

  return (
    <section className="relative h-[75vh] md:h-[85vh] overflow-hidden" aria-label="Hero banner kopi Crestora">
      <Helmet>
        <link rel="preload" as="image" href={heroImage} type="image/webp" />
      </Helmet>
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === current ? "opacity-100" : "opacity-0"
          }`}
          aria-hidden={index !== current}
        >
          <img
            src={slide.image}
            alt={slide.alt}
            className="w-full h-full object-cover"
            width={1200}
            height={800}
            {...(index === 0 ? { fetchPriority: "high" as const } : { loading: "lazy" as const })}
          />
          <div className="absolute inset-0 bg-espresso/50" />
        </div>
      ))}

      <div className="relative z-10 h-full flex items-end pb-8 md:pb-14">
        <div className="container mx-auto px-4 md:px-8">
          <h1
            className={`font-display text-3xl md:text-6xl lg:text-[72px] font-bold text-cream leading-[1.1] max-w-4xl transition-all duration-1000 ease-out ${
              textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Kopi Spesial<br />
            Kualitas Terbaik
          </h1>
        </div>
      </div>

      <button
        onClick={() => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-4 bottom-8 md:left-6 md:top-1/2 md:-translate-y-1/2 z-20 w-12 h-12 rounded-full border-2 border-cream flex items-center justify-center text-cream hover:border-crestora-gold hover:text-crestora-gold transition-colors text-xl md:text-2xl"
        aria-label="Slide sebelumnya"
      >
        &#8249;
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
        className="absolute right-4 bottom-8 md:right-6 md:top-1/2 md:-translate-y-1/2 z-20 w-12 h-12 rounded-full border-2 border-cream flex items-center justify-center text-cream hover:border-crestora-gold hover:text-crestora-gold transition-colors text-xl md:text-2xl"
        aria-label="Slide berikutnya"
      >
        &#8250;
      </button>
    </section>
  );
};

export default HeroSection;
